import { APIResponse, ScoreResponse, ObjectiveResponse, HistoricResponse, CpfLookout, NegativeInfo } from './types';
import { queryOptions } from '@tanstack/react-query';
import { identityApi } from '@common/services/identity.api';

// API Call
const fetchScoreData = async () => {
  const endpoint = '/v2/app/score';
  const { data } = await identityApi.get<APIResponse<ScoreResponse>>(endpoint);

  if (!data.data) {
    throw new Error('Failed to fetch score data');
  }

  return data.data;
};

const fetchObjectivesData = async () => {
  const endpoint = '/v2/app/score/objectives';
  const { data } = await identityApi.get<APIResponse<ObjectiveResponse[]>>(endpoint);

  if (!data.data) {
    throw new Error('Failed to fetch objectives data');
  }

  return data.data;
};

const fetchHistoryData = async () => {
  const endpoint = '/v2/app/score/history';
  const { data } = await identityApi.get<APIResponse<HistoricResponse[]>>(endpoint);

  if (!data.data) {
    throw new Error('Failed to fetch history data');
  }

  return data.data;
};

const fetchNegativeData = async () => {
  const endpoint = '/v2/app/customer/negative-data';
  const { data } = await identityApi.get<APIResponse<NegativeInfo[]>>(endpoint);
  if (!data.data) {
    throw new Error('Failed to fetch negative data');
  }
  return data.data;
};

const fetchCpfLookoutData = async () => {
  const endpoint = '/v2/app/customer/consults';
  const { data } = await identityApi.get<APIResponse<CpfLookout[]>>(endpoint);
  if (!data.data) {
    throw new Error('Failed to fetch CPF lookout data');
  }
  return data.data;
};

// Query Factory
export const scoreQueries = {
  _all: [{ scope: 'score' }] as const,

  score: () =>
    queryOptions({
      queryKey: [{ ...scoreQueries._all, entity: 'point' }] as const,
      queryFn: fetchScoreData,
    }),

  objectives: () =>
    queryOptions({
      queryKey: [{ ...scoreQueries._all, entity: 'objectives' }] as const,
      queryFn: fetchObjectivesData,
    }),

  history: () =>
    queryOptions({
      queryKey: [{ ...scoreQueries._all, entity: 'history' }] as const,
      queryFn: fetchHistoryData,
    }),

  negative: () =>
    queryOptions({
      queryKey: [{ ...scoreQueries._all, entity: 'negative' }] as const,
      queryFn: fetchNegativeData,
    }),

  cpfLookout: () =>
    queryOptions({
      queryKey: [{ ...scoreQueries._all, entity: 'cpfLookout' }] as const,
      queryFn: fetchCpfLookoutData,
    }),
};
